export var RouteName;
(function (RouteName) {
    RouteName["HOME_PAGE"] = "/";
    RouteName["APPS_PAGE"] = "/apps";
    RouteName["TOKEN_PAGE"] = "/token/:id";
    RouteName["NOT_FOUND_PAGE"] = "*";
})(RouteName || (RouteName = {}));
